import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ChairProblem } from './components/ChairProblem';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { CreatedBy } from './components/CreatedBy';
import { Volumes } from './components/Volumes';
import { Tools } from './components/Tools';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-cream-100" data-id="element-0" data-mp="23v2rsz5cwt3a">
      <MetaPixel data-id="element-1" data-mp="3ik7e6ay3c1o0" />
      <main data-id="element-2" data-mp="3ikqytzf4l45q">
        <Hero data-id="element-3" data-mp="3ij64a9st9l7v" />
        <ChairProblem data-id="element-4" data-mp="3ijftvw9y1qd1" />
        <BeforeAfter data-id="element-5" data-mp="3ii4ro0w5cqo1" />
        <PainPoints data-id="element-6" data-mp="3mlat8v8bdto6" />
        <CreatedBy data-id="element-7" data-mp="3mkhlbqxmcy4g" />
        <Volumes data-id="element-8" data-mp="3mjzrt22ccy08" />
        <Tools data-id="element-9" data-mp="3mjga9mglsbmq" />
        <Bonuses data-id="element-10" data-mp="3rc9f0ac2njyt" />
        <Offer data-id="element-11" data-mp="3rbr9so7flver" />
        <Guarantee data-id="element-12" data-mp="3rbzpsoyupgu6" />
        <Testimonials data-id="element-13" data-mp="3rcsy3udgkeef" />
        <Author data-id="element-14" data-mp="3reccfffk0fdk" />
        <FAQ data-id="element-15" data-mp="5yi8qe3h5da" />
        <FinalCTA data-id="element-16" data-mp="6hqffdy0fe4" />
      </main>
      <Footer data-id="element-17" data-mp="4n5w26l2pak" />
      <FloatingCTA data-id="element-18" data-mp="56ntiw8hdol" />
      <PurchasePopup data-id="element-19" data-mp="7svdij4jt6t" />
    </div>;
}